import { NavItem, UncontrolledTooltip } from 'reactstrap'
import React from 'react'

export const Phone = ({ phone }) => {
  return phone ? (
    <NavItem className="d-down-none conwayred" style={{ paddingLeft: '10px' }}>
      <a
        className="conwayred"
        id="contactphone"
        href={'tel:' + phone}
        style={{ marginBottom: '0' }}
      >
        <i className="icon-phone font-weight-bold" /> {phone}
      </a>
      <UncontrolledTooltip placement="left" target="contactphone">
        Teléfono de contacto
      </UncontrolledTooltip>
    </NavItem>
  ) : null
}
